<ion-accordion-group
  value="numbers"
  class="border-r10 grey-border no-shadow bg-white ion-margin"
>
  <ion-accordion value="open" (click)="handleBookingAccordionAction(requestDetail)">
    <ion-item class="ion-no-padding ion-no-margin marb5" slot="header">
      <ion-thumbnail slot="start">
        <img
          [alt]="
            serviceDetails[requestDetail.serviceId]?.img ||
            requestDetail?.img ||
            imagePlaceholder
          "
          [src]="
            serviceDetails[requestDetail.serviceId]?.img ||
            requestDetail?.img ||
            imagePlaceholder
          "
        />
      </ion-thumbnail>
      <ion-label class="padr10">
        <h3 class="fs-2 font600 accordian-title-text-color">
          {{
            serviceDetails[requestDetail.serviceId]?.title ||
              requestDetail?.title
          }}
        </h3>
        <p class="fs-1 font500 accordian-subtitle-text-color mar0">
          {{ travelDate | smartdate : "mediumDate" }}
        </p>
      </ion-label>
      <ion-label
        slot="end"
        class="fs-2 font500 ion-text-capitalize accordian-subtitle-text-color status"
        >{{ requestDetail.status }}</ion-label
      >
    </ion-item>
    <ion-item
      class="txn-info bg-white ion-no-padding ion-no-margin padl8"
      lines="none"
      slot="content"
    >
      <ion-label class="ion-no-margin ion-padding-end">
        <p class="fs-2 font500 transaction-detail accordian-subtitle-text-color mar0">
          {{ "activities.booking_item.transaction_id" | translate }} :
          {{ requestDetail?.requestId }}
        </p>
      </ion-label>
    </ion-item>
    <ion-item
      class="txn-info bg-white ion-no-padding ion-no-margin padl8"
      lines="none"
      slot="content"
    >
      <ion-label class="mart0 price" *ngIf="serviceType?.type !== 'restaurant' && serviceType?.type !== 'gym' ">
        <p *ngIf="requestDetail?.type !== 'debit' " class="fs-2 font500 accordian-subtitle-text-color mar0">
          {{ "activities.booking_item.order_value" | translate }} :
          {{(requestDetail?.finalAmount ? requestDetail?.finalAmount / 100 : requestDetail?.price) | currency : currencyCode }}
        </p>
      </ion-label>

      <ion-button  *ngIf="serviceType?.type === 'restaurant' || serviceType?.type === 'gym'" 
         (click)="redirectToCodePage()"
        class="l-spacing0 fs-2 font500  primary-btn view-code-btn">
        View Code
      </ion-button>
    </ion-item>
  </ion-accordion>
</ion-accordion-group>
